import {
  TextField,
  DateField,
  TextInput,
  BooleanField,
  NullableBooleanInput,
  // Link,
  // FunctionField,
} from 'react-admin'
import { DateInput, Datagrid, List, Filter } from '../../custom'
import { dateWithTimeFieldOptions, booleanFieldOptions } from '../../util/component-options'
import { useLabel } from '../../../hooks'
import DownloadButton from './download-button'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
  {
    booleanFieldHeader: {
      textAlign: 'center',
    },
  },
)

const TonnageTicketUploadsFilter = props => {
  const label = useLabel(props)

  return (
    <Filter>
      <TextInput label={label('ticket_image_filename', 'find')} source='ticket_image_blob_filename_i_cont' />
      <TextInput label={label('sender', 'filter')} source='sender_phone_eq' />
      <TextInput label={label('sender_truck', 'filter')} source='sender_truck_number_i_cont' />
      <NullableBooleanInput label={label('is_sms')} source='is_sms_true' />
      <DateInput
        label={label('created_at', 'start')}
        source='created_at_gteq'
      />
      <DateInput
        label={label('created_at', 'end')}
        source='created_at_lt'
      />
    </Filter>
  )
}

const TonnageTicketUploadsList = props => {
  const label = useLabel(props)
  const classes = useStyles(props)

  return (
    <List
      {...props}
      filters={<TonnageTicketUploadsFilter />}
      actions={<DownloadButton />}
    >
      <Datagrid
        hasEdit
      >
        {/* <TextField source='ticket_image_filename' label={label('ticket_image_filename')} sortBy='ticket_image_blob_filename' /> */}
        <TextField source='sender.phone' label={label('sender')} sortBy='sender_phone' />
        <TextField source='sender.truck.number' label={label('sender_truck')} sortBy='sender_phone' />
        {/* <FunctionField label={label('tonnage_ticket_pdf_upload')} sortBy={'tonnage_ticket_pdf_upload_pdf_file_blob_filename'} render={record => {
          const { tonnage_ticket_pdf_upload } = record
          return (
            tonnage_ticket_pdf_upload &&
            <Link to={`/tonnage_ticket_pdf_uploads/${tonnage_ticket_pdf_upload.id}`}>
              { tonnage_ticket_pdf_upload.pdf_filename }
            </Link>
          )
        }} /> */}
        <BooleanField {...booleanFieldOptions} source='is_sms' label={label('is_sms')} headerClassName={classes.booleanFieldHeader} />
        <DateField source='created_at' label={label('created_at')} options={dateWithTimeFieldOptions}/>
      </Datagrid>
    </List>
  )
}

export default TonnageTicketUploadsList
